<template>
  <div>
    <header class='lib__form__main__header'>
      <h2 class="lib__h2">{{$t('e-mobility.car-specification-step.modelKnownQuestion')}}
        <div class="lib__tooltips">
          <span @click="onTitleTooltipClick()">
            <i class="fas fa-info-circle lib__clickable-tooltips"></i>
          </span>
        </div>
      </h2>
    </header>
      <ValidationProvider rules="required" slim v-slot="state">
    <div :class="validationState(state)" class="lib__field">
      <div class="lib__tiles">
        <TileRadio :item="tileYes"  :label="$t('common.yes')" data-cy="tile-yes" group="vehicleKnown" v-model="modelKnown"></TileRadio>
        <TileRadio :item="tileNo" :label="$t('common.no')" data-cy="tile-no" group="vehicleKnown" v-model="modelKnown"></TileRadio>
      </div>
      <error-message :error="state.errors[0]"></error-message>
    </div>
  </ValidationProvider>

    <ModalDialog :closeable="$t('common.close')" :open.sync="isTitleTooltipOpen" size="default">
      <p v-html="$t('e-mobility.car-specification-step.modelKnownQuestionModal')"></p>
    </ModalDialog>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator'
import { State } from 'vuex-class'
import FieldBox from '../../Shared/FieldBox'
@Component({
  name: 'electric-vehicle-question-form'
})
export default class ElectricVehicleQuestionForm extends FieldBox {

  //#region [Property]
  @Prop({ required: true }) public readonly value!: boolean | null
  //#endregion

  //#region [Data]
  public readonly tileYes: string = 'yes'
  public readonly tileNo: string = 'no'
  public isTitleTooltipOpen: boolean = false

  @State('requestId', { namespace: 'eMobility' })
  public requestId!: string
  //#endregion

  //#region [Computed]
  public get modelKnown(): string | null {
    if (this.value === null || this.value === undefined) {
      return null
    }
    return this.value ? this.tileYes : this.tileNo
  }

  public set modelKnown(val: string | null) {
    if (val === this.tileYes) {
      this.$emit('input', true)
    } else if (val === this.tileNo) {
      this.$emit('input', false)
    } else {
      this.$emit('input', null)
    }
  }
  //#endregion

  //#region [Method]
  public onTitleTooltipClick(): void {
    this.$appInsights.trackEvent('EMobility_TooltipClick', {
      Segment: 'EMobility',
      WebRef: this.requestId,
      Tooltip: 'CarModelKnow?'
    })
    this.isTitleTooltipOpen = !this.isTitleTooltipOpen
  }
  //#endregion
}
</script>